<template>
  <component :is="layout.page" :id="id" :key="id" />
</template>

<script>
import { mapState } from 'vuex'
import { resolveLayout } from '@/helpers/companyLayouts'

// Shows the shipment detail page of the user's company layout
export default {
  name: 'PraticaDetailPage',
  props: ['id'],
  computed: {
    ...mapState('account', ['companyLayout']),
    layout() {
      return resolveLayout(this.companyLayout)
    },
  },
}
</script>
